module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message space",
    class: _vm.isOwn ? 'self' : 'other'
  }, [_c('div', {
    staticClass: "messaged-time"
  }, [_vm._v(_vm._s(_vm.toLocalDateString(_vm.message.created_at)))]), _vm._v(" "), (_vm.message.attachment) ? [_c('div', {
    staticClass: "message-section"
  }, [_c('router-link', {
    attrs: {
      "to": ("/" + (_vm.message.sender.slug))
    }
  }, [_c('div', {
    staticClass: "user-avatar-image",
    style: ({
      'background-image': 'url(' + _vm.message.sender.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "messaged-time"
  }, [_vm._v("\n        " + _vm._s(_vm.timePeriodFormat(new Date(_vm.message.created_at))) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "message-content text"
  }, [_c('label', {
    staticClass: "text-message",
    domProps: {
      "innerHTML": _vm._s(_vm.message.body)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "message-section"
  }, [_c('router-link', {
    attrs: {
      "to": ("/" + (_vm.message.sender.slug))
    }
  }, [_c('div', {
    staticClass: "user-avatar-image",
    style: ({
      'background-image': 'url(' + _vm.message.sender.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "messaged-time"
  }, [_vm._v("\n        " + _vm._s(_vm.timePeriodFormat(new Date(_vm.message.created_at))) + "\n      ")]), _vm._v(" "), (_vm.message.attachment.attachment_type == 'repost') ? [_c('div', {
    staticClass: "message-content text request no-top-corner"
  }, [_c('div', [_c('div', {
    staticClass: "repost-status-section"
  }, [(
    _vm.message.sender.id == _vm.currentUser.id &&
    _vm.message.attachment.status == 'pending'
  ) ? _c('v-icon', {
    staticClass: "icon-close",
    on: {
      "click": function($event) {
        _vm.removeRepostRequest(_vm.message)
      }
    }
  }, [_vm._v("close")]) : _vm._e(), _vm._v(" "), (
    _vm.message.sender.id == _vm.currentUser.id ||
    _vm.message.attachment.status != 'pending'
  ) ? _c('div', [_c('label', {
    staticClass: "status-title"
  }, [_vm._v("Repost request: ")]), _vm._v(" "), _c('span', {
    class: _vm.message.attachment.status
  }, [_vm._v(_vm._s(_vm.message.attachment.status))])]) : _c('div', [_c('label', {
    staticClass: "status-title"
  }, [_vm._v("Repost request: ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn--accept",
    nativeOn: {
      "click": function($event) {
        _vm.acceptRepostRequest(_vm.message)
      }
    }
  }, [_vm._v("Accept")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn--deny",
    nativeOn: {
      "click": function($event) {
        _vm.denyRepostRequest(_vm.message)
      }
    }
  }, [_vm._v("Deny")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn--free",
    nativeOn: {
      "click": function($event) {
        _vm.acceptRepostRequestOnFree(_vm.message)
      }
    }
  }, [_vm._v("Repost free")])], 1)], 1), _vm._v(" "), (_vm.message.attachment.attachable_type == 'Album') ? _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "repost-item-image"
  }, [_c('activity-album-card', {
    attrs: {
      "object": _vm.message.attachment.assoc
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "info-section"
  }, [_c('label', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.message.attachment.assoc.name))]), _vm._v(" "), _c('a', {
    staticClass: "item-user"
  }, [_vm._v(_vm._s(_vm.message.sender.username))])])]) : (_vm.message.attachment.attachable_type == 'ShopProduct') ? _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "repost-item-image"
  }, [_c('activity-product-card', {
    attrs: {
      "object": _vm.message.attachment.assoc,
      "price-show": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "info-section"
  }, [_c('label', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.message.attachment.assoc.name))]), _vm._v(" "), _c('a', {
    staticClass: "item-user"
  }, [_vm._v(_vm._s(_vm.message.sender.username))])])]) : _vm._e()])])] : (_vm.message.attachment.attachment_type == 'collaboration') ? [_c('div', {
    staticClass: "message-content text request no-top-corner"
  }, [_c('div', [_c('div', {
    staticClass: "content-section"
  }, [(_vm.message.attachment.attachable_type == 'Album') ? [_c('div', {
    staticClass: "repost-item-image"
  }, [_c('activity-album-card', {
    attrs: {
      "object": _vm.message.attachment.assoc
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "info-section"
  }, [_c('label', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.message.attachment.assoc.name))]), _vm._v(" "), _c('a', {
    staticClass: "item-user"
  }, [_vm._v(_vm._s(_vm.message.sender.username))])]), _vm._v(" "), (_vm.message.attachment.assoc.collaborators.length > 0) ? _c('div', {
    staticClass: "artist-list"
  }, _vm._l((_vm.message.attachment.assoc.collaborators), function(c) {
    return _c('div', {
      key: c.id,
      staticClass: "artist"
    }, [_c('span', [_vm._v(_vm._s(c.user.username))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(c.user_role))])])
  })) : _vm._e()] : (
    _vm.message.attachment.attachable_type == 'ShopProduct'
  ) ? [_c('div', {
    staticClass: "repost-item-image"
  }, [_c('activity-product-card', {
    attrs: {
      "object": _vm.message.attachment.assoc,
      "price-show": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "info-section"
  }, [_c('label', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.message.attachment.assoc.name))]), _vm._v(" "), _c('a', {
    staticClass: "item-user"
  }, [_vm._v(_vm._s(_vm.message.sender.username))])]), _vm._v(" "), (_vm.message.attachment.assoc.collaborators.length > 0) ? _c('div', {
    staticClass: "artist-list"
  }, [_c('div', {
    staticClass: "artist"
  }, [_c('span', [_vm._v(_vm._s(_vm.message.attachment.assoc.merchant.username) + "( Owner\n                      )")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.message.attachment.assoc.creator_share) + " %")])]), _vm._v(" "), _c('div', {
    staticClass: "artist"
  }, [_c('span', [_vm._v("Recoup Cost")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.message.attachment.assoc.creator_recoup_cost)))])]), _vm._v(" "), _vm._l((_vm.message.attachment.assoc.collaborators), function(c) {
    return _c('div', {
      key: c.id,
      staticClass: "artist"
    }, [_c('span', [_vm._v(_vm._s(c.user.username))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(c.user_share) + " %")])])
  })], 2) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "repost-status-section label"
  }, [(
    _vm.message.sender.id == _vm.currentUser.id ||
    _vm.message.attachment.status != 'pending'
  ) ? _c('div', [(_vm.message.attachment.attachable_type == 'Album') ? _c('v-btn', {
    attrs: {
      "to": "/albums#pending"
    }
  }, [_vm._v("View & Release")]) : (
    _vm.message.attachment.attachable_type == 'ShopProduct'
  ) ? _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'ManageIndex',
          params: {
            activeInnerFilter: 'products',
            activeInnerTab: 'pending'
          }
        })
      }
    }
  }, [_vm._v("View & Release")]) : _vm._e()], 1) : _c('div', [(_vm.message.attachment.attachable_type == 'Album') ? _c('v-btn', {
    attrs: {
      "to": "/albums#pending"
    }
  }, [_vm._v("View Pending Collaboration")]) : (
    _vm.message.attachment.attachable_type == 'ShopProduct'
  ) ? _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'ManageIndex',
          params: {
            activeInnerFilter: 'products',
            activeInnerTab: 'pending'
          }
        })
      }
    }
  }, [_vm._v("View Pending Collaboration")]) : _vm._e()], 1)])], 2)])])] : (_vm.message.attachment.attachment_type == 'label_user') ? [_c('div', {
    staticClass: "message-content text request no-top-corner"
  }, [_c('div', [_c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "label-message-section"
  }, [_c('div', {
    staticClass: "label-message"
  }, [_vm._v(_vm._s(_vm.message.body))])]), _vm._v(" "), (_vm.message.attachment.attachable_type == 'User') ? [_c('div', {
    staticClass: "repost-item-image avatar",
    style: ({
      'background-image': 'url(' +
        _vm.message.attachment.assoc.avatar.thumb.url +
        ')',
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "info-section"
  }, [_c('label', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.message.attachment.assoc.username))])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "repost-status-section label"
  }, [(
    _vm.message.sender.id == _vm.currentUser.id ||
    _vm.message.attachment.status != 'pending'
  ) ? _c('div', [_c('span', {
    class: _vm.message.attachment.status
  }, [_vm._v(_vm._s(_vm.message.attachment.status))])]) : _c('div', [_c('v-btn', {
    staticClass: "btn--accept",
    nativeOn: {
      "click": function($event) {
        _vm.acceptLabelUser(_vm.message)
      }
    }
  }, [_vm._v("Accept")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn--deny",
    nativeOn: {
      "click": function($event) {
        _vm.denyLabelUser(_vm.message)
      }
    }
  }, [_vm._v("Deny")])], 1)])], 2)]), _vm._v(" "), (false) ? _c('label', {
    staticClass: "text-message"
  }) : _vm._e()])] : (_vm.message.attachment.attachment_type == 'label_album') ? [_c('div', {
    staticClass: "message-content text request no-top-corner"
  }, [_c('div', [_c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "label-message-section"
  }, [_c('div', {
    staticClass: "label-message"
  }, [_vm._v(_vm._s(_vm.message.body))])]), _vm._v(" "), (_vm.message.attachment.attachable_type == 'Album') ? [_c('div', {
    staticClass: "repost-item-image avatar",
    style: ({
      'background-image': 'url(' + _vm.message.attachment.assoc.cover.url + ')',
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "info-section"
  }, [_c('label', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.message.attachment.assoc.name))])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "repost-status-section label"
  }, [(
    _vm.message.sender.id == _vm.currentUser.id ||
    _vm.message.attachment.status != 'pending'
  ) ? _c('div', [_c('span', {
    class: _vm.message.attachment.status
  }, [_vm._v(_vm._s(_vm.message.attachment.status))])]) : _c('div', [_c('v-btn', {
    staticClass: "btn--accept",
    nativeOn: {
      "click": function($event) {
        _vm.acceptLabelAlbum(_vm.message)
      }
    }
  }, [_vm._v("Accept")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn--deny",
    nativeOn: {
      "click": function($event) {
        _vm.denyLabelAlbum(_vm.message)
      }
    }
  }, [_vm._v("Deny")])], 1)])], 2)])])] : (_vm.message.attachment.attachment_type == 'sample_album') ? [_c('div', {
    staticClass: "message-content text request no-top-corner"
  }, [_c('div', [(_vm.message.attachment.attachable_type == 'Album') ? _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "repost-item-image"
  }, [_c('activity-album-card', {
    attrs: {
      "object": _vm.message.attachment.assoc
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "info-section"
  }, [_c('label', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.message.attachment.assoc.name))]), _vm._v(" "), _c('a', {
    staticClass: "item-user"
  }, [_vm._v(_vm._s(_vm.message.sender.username))])])]) : _vm._e()])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 2)] : [_c('div', {
    staticClass: "message-section"
  }, [_c('router-link', {
    attrs: {
      "to": ("/" + (_vm.message.sender.slug))
    }
  }, [_c('div', {
    staticClass: "user-avatar-image",
    style: ({
      'background-image': 'url(' + _vm.message.sender.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "messaged-time"
  }, [_vm._v("\n        " + _vm._s(_vm.timePeriodFormat(new Date(_vm.message.created_at))) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "message-content text"
  }, [_c('label', {
    staticClass: "text-message",
    domProps: {
      "innerHTML": _vm._s(_vm.message.body)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d00e0554","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/messages/components/message.vue
// module id = 1851
// module chunks = 180